import { render, staticRenderFns } from "./UploadV2Picker.vue?vue&type=template&id=0595ab40&scoped=true"
import script from "./UploadV2Picker.vue?vue&type=script&lang=js"
export * from "./UploadV2Picker.vue?vue&type=script&lang=js"
import style0 from "./UploadV2Picker.vue?vue&type=style&index=0&id=0595ab40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0595ab40",
  null
  
)

export default component.exports